import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EditModeService {
  private isEditModeSubject = new BehaviorSubject<boolean>(false);

  get isEditMode$(): Observable<boolean> {
    return this.isEditModeSubject.asObservable();
  }

  get isEditMode(): boolean {
    return this.isEditModeSubject.value;
  }

  setEditMode(isEdit: boolean): void {
    this.isEditModeSubject.next(isEdit);
  }

  clearEditMode(): void {
    this.isEditModeSubject.next(false);
  }
}
